import RectangleShapeComponent from "./rectangle-shape-component";
import RectangleShapeConfig from "./rectangle-shape-config";
import RectangleShapeAdvancedConfig from "./rectangle-shape-advanced-config";

export default {
  RectangleShapeComponent,
  RectangleShapeConfig,
  RectangleShapeAdvancedConfig
};
